<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信设置HIK域名/IP'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="DomainName" label="选择服务器通道">
        <Select v-model="DomainName" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="ip" label="IP/域名">
        <Input v-model="ip" placeholder="IP/域名" style="width: 220px;"  @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="port" label="端口">
        <Input v-model="port" placeholder="端口" style="width: 220px;"  @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="sms" label="短信内容">
        <Input v-model="sms" readonly placeholder="短信内容" style="width: 300px;">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikipportsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //域名选项
        DomainName:null,
        DomainNameOptions: [
          {name: '服务器通道1(JC)', value: 0},
          {name: '服务器通道2(运维)', value: 1},
          {name: '服务器通道3(货运)', value: 2},
          {name: '服务器通道4(两客一危)', value: 3},
          {name: '服务器通道5', value: 4},
          {name: '服务器通道6', value: 5},
        ],
        ip:null,
        port:null,

        sms:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onChange(){
        this.sms = 'ZIP:'+ this.DomainName +',' + this.ip + ',' + this.port + ';A'
      },
      onOk() {
        if (this.DomainName == null || this.DomainName === '') {
          this.$Message.error('请选择服务器通道')
          return
        }
        if (this.ip == null || this.ip === '') {
          this.$Message.error('请填写IP/域名')
          return
        }
        if (this.port == null || this.port === '') {
          this.$Message.error('请填写端口')
          return
        }
          //                     通道                 IP/域名           端口
          this.sendSMS('ZIP:'+ this.DomainName +',' + this.ip + ',' + this.port + ';A')

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
